module.exports = __webpack_public_path__ + "static/media/news-02.b0398700.jpg";